export default {"src":"/_next/static/media/sailFooter.0730fb47.svg","height":32,"width":138,"blurWidth":0,"blurHeight":0};